export class ClearAllEvent {

}
export class ScopeChangedEvent {

}
